// extracted by mini-css-extract-plugin
module.exports = {"button":"SquareRadioButton_button__Oy_jw","active":"SquareRadioButton_active__Edma-","error":"SquareRadioButton_error__2FxkM"};